import { useEffect, useRef } from 'react';

function injectTradingViewWidget(container: HTMLDivElement | null, src: string, config: object) {
  if (!container) return;
  container.innerHTML = '';
  const script = document.createElement('script');
  script.src = src;
  script.type = 'text/javascript';
  script.async = true;
  script.innerHTML = JSON.stringify(config);
  container.appendChild(script);
}

export default function StockMarketTicker() {
  const tapeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    injectTradingViewWidget(
      tapeRef.current,
      'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js',
      {
        symbols: [
          { proName: 'CAPITALCOM:US500', title: 'S&P 500' },
          { proName: 'CAPITALCOM:US100', title: 'Nasdaq 100' },
          { proName: 'CAPITALCOM:US30', title: 'Dow 30' },
          { proName: 'CAPITALCOM:UK100', title: 'FTSE 100' },
          { proName: 'CAPITALCOM:DE40', title: 'DAX 40' },
          { proName: 'CAPITALCOM:FR40', title: 'CAC 40' },
          { proName: 'CAPITALCOM:JP225', title: 'Nikkei 225' },
          { proName: 'CAPITALCOM:HK50', title: 'Hang Seng' },
          { proName: 'CAPITALCOM:AU200', title: 'ASX 200' },
          { proName: 'CAPITALCOM:ES35', title: 'IBEX 35' },
        ],
        showSymbolLogo: false,
        isTransparent: true,
        displayMode: 'adaptive',
        colorTheme: 'light',
        locale: 'en',
      }
    );

    return () => {
      if (tapeRef.current) tapeRef.current.innerHTML = '';
    };
  }, []);

  return (
    <div className="relative overflow-hidden rounded-2xl border border-blue-200/60 bg-gradient-to-br from-white to-blue-50 shadow-sm">
      <div className="[&_.tradingview-widget-container]:w-full">
        <div ref={tapeRef} className="tradingview-widget-container" />
      </div>
    </div>
  );
}

